import { EventViewData } from 'components/eventView/pages/eventData';

export const NlsDays2023Event: EventViewData = {
    eventId: 'nlsdays2023',
    mapId: '12d1bfce-07cc-4f95-9c64-2f48131ae58f',
    guideId: '8275b8b7-d8f9-4882-be4c-f7c6109af606',
    programSettings: {
        showAddToCalendar: true,
        timezone: 'Europe/Stockholm',
        searchable: true,
        speakersListId: '5b826e08-e816-43cb-9bdd-0ec26c14e240'
    }
};
